<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v">CONTENTS</a></p><a id="page_v">
<p class="imageb"><img alt="image" src="images/pgv.jpg"/></p>
</a><p class="toca"><a id="page_v"></a><a href="#/xhtml/06_Acknowledgement">Acknowledgments</a></p>
<p class="toca"><a href="#/xhtml/08_Introduction">Introduction:<br/>THE CONTINENTAL DIVIDE</a></p>
<p class="tocb"><a href="#/xhtml/09_Chapter01">1.  HUMBLE BEGINNINGS</a></p>
<p class="tocb"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample">2.  COMING TOGETHER</span></p>
<p class="tocb"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample">3.  A DEPOT WORTHY OF CHICAGO</span></p>
<p class="tocb"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample">4.  A MOST PUBLIC SERVICE</span></p>
<p class="tocb"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample">5.  A COLOSSUS OF THE ROADS</span></p>
<p class="tocb"><span href="#/xhtml/14_Chapter06" title="Link target outside of Sample">6.  A CITY WITHIN A CITY</span></p>
<p class="tocb"><span href="#/xhtml/15_Chapter07" title="Link target outside of Sample">7.  RED INK IN THE WHITE CITY</span></p>
<p class="tocb"><span href="#/xhtml/16_Chapter08" title="Link target outside of Sample">8.  REMODELING THE DEPOT, REMAKING THE CITY</span></p>
<p class="toc"><span href="#/xhtml/17_Appendix01" title="Link target outside of Sample">Appendix A: Chicago’s Railroad Terminals</span></p>
<p class="toc"><span href="#/xhtml/18_Appendix02" title="Link target outside of Sample">Appendix B: Naming Conventions</span></p>
<p class="toc"><span href="#/xhtml/19_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/21_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?3448fe5f